import React from "react";
import "./Particle.css";

const Particles = () => {
  return (
    <div class="wrap">
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
      <div class="c"></div>
    </div>
  );
};

export default Particles;
